import Card from "./components/Card.vue";
import AIVDialog from "@/components/AIVDialog.vue";
import AIVRow from "@/components/AIVRow.vue";
import AIVSelect from "@/components/AIVSelect.vue";
import AIVTable from "@/components/AIVTable.vue";
import AIVTimeSelect from "@/components/AIVTimeSelect.vue";
import PaginationComponent from "@/components/Pagination.vue";
import { BSpinner } from "bootstrap-vue";
import {
  Button,
  Checkbox,
  CheckboxGroup,
  DatePicker,
  Dialog,
  Form,
  FormItem,
  Alert,
  Steps,
  Step,
  Icon,
  Input,
  InputNumber,
  MessageBox,
  Notification,
  Option,
  Pagination,
  Progress,
  Select,
  Switch,
  Table,
  TabPane,
  Tabs,
  Tag,
  TableColumn,
  Tooltip,
  Upload,
} from "element-ui";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const GlobalComponents = {
  install(Vue) {
    Vue.prototype.$notify = function (msg, type = "info") {
      // Check if message contains HTML tags
      const containsHtml = /<br\s*\/?>|<[a-z][\s\S]*>/i.test(msg);

      Notification({
        message: msg,
        type,
        position: "bottom-right",
        duration: containsHtml ? 8000 : 4000, // Longer duration for HTML messages
        dangerouslyUseHTMLString: containsHtml,
      });
    };
    Vue.prototype.$notifySuccess = function (msg) {
      this.$notify(msg, "success");
    };
    Vue.prototype.$notifyError = function (msg) {
      this.$notify(msg, "error");
    };
    Vue.prototype.$notifyInfo = function (msg) {
      this.$notify(msg, "info");
    };
    Vue.prototype.$confirm = MessageBox.confirm;
    Vue.prototype.$prompt = MessageBox.prompt;
    Vue.prototype.$alert = MessageBox.alert;
    Vue.prototype.$confirmAction = function (onConfirm, message = "Are you sure?") {
      return MessageBox.confirm(message, "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          if (onConfirm) onConfirm();
          return true;
        })
        .catch(() => {
          return false;
        });
    };

    Vue.component("card", Card);
    Vue.component("AIVDialog", AIVDialog);
    Vue.component("AIVRow", AIVRow);
    Vue.component("AIVSelect", AIVSelect);
    Vue.component("AIVTable", AIVTable);
    Vue.component("AIVTimeSelect", AIVTimeSelect);
    Vue.component("pagination", PaginationComponent);
    Vue.component("BSpinner", BSpinner);
    Vue.component("el-button", Button);
    Vue.component("el-checkbox", Checkbox);
    Vue.component("el-checkbox-group", CheckboxGroup);
    Vue.component("el-date-picker", DatePicker);
    Vue.component("el-dialog", Dialog);
    Vue.component("el-form", Form);
    Vue.component("el-form-item", FormItem);
    Vue.component("el-icon", Icon);
    Vue.component("el-input", Input);
    Vue.component("el-input-number", InputNumber);
    Vue.component("el-option", Option);
    Vue.component("el-pagination", Pagination);
    Vue.component("el-progress", Progress);
    Vue.component("el-select", Select);
    Vue.component("el-switch", Switch);
    Vue.component("el-tab-pane", TabPane);
    Vue.component("el-tabs", Tabs);
    Vue.component("el-table", Table);
    Vue.component("el-tag", Tag);
    Vue.component("el-table-column", TableColumn);
    Vue.component("el-tooltip", Tooltip);
    Vue.component("el-upload", Upload);
    Vue.component("el-alert", Alert);
    Vue.component("el-steps", Steps);
    Vue.component("el-step", Step);
    Vue.component("ValidationProvider", ValidationProvider);
    Vue.component("ValidationObserver", ValidationObserver);
  },
};

export default GlobalComponents;
